module.exports = __webpack_public_path__ + "static/media/sidebar_ranking_inactive.56c9cdb1.svg";